(function(angular){
	'use strict';
	
	angular
		.module('campaignLandingModule')
		.controller('CampaignLanding', [
			'APP_BASE_PATH',
			CampaignLandingControllerFunction
		]);
	
	function CampaignLandingControllerFunction(
		APP_BASE_PATH
	){
		var campaignLanding = this;
		campaignLanding.destination = APP_BASE_PATH + '/start-investing';
	}
})(window.angular);